var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedulerIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "27px",
    viewBox: "0 0 35 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Scheduler_icon(green)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/scheduler/scheduler-(green)-**",
    transform: "translate(-16.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scheduler_icon(green)",
    transform: "translate(16.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5f00a0",
    x: 0,
    y: 0,
    width: 30.0444444,
    height: 23.6063492,
    rx: 1.07301587
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 22.2114286,
    y: 0,
    width: 1,
    height: 1.93142857
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#FFFFFF",
    x: 6.76,
    y: 0,
    width: 1,
    height: 1.93142857
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 2.14603175,
    y: 18.455873,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 9.12063492,
    y: 18.455873,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 16.0952381,
    y: 18.455873,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    x: 23.0698413,
    y: 18.455873,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    x: 2.14603175,
    y: 13.0907937,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#FFFFFF",
    x: 9.12063492,
    y: 13.0907937,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    x: 16.0952381,
    y: 13.0907937,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    x: 23.0698413,
    y: 13.0907937,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "#FFFFFF",
    x: 2.14603175,
    y: 7.72571429,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 9.12063492,
    y: 7.72571429,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF",
    x: 16.0952381,
    y: 7.72571429,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    x: 23.0698413,
    y: 7.72571429,
    width: 4.82857143,
    height: 3.21904762,
    rx: 0.536507937
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.536507937,
    y1: 5.0431746,
    x2: 29.5079365,
    y2: 5.0431746,
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.07301587,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(18.571429, 10.214286)",
    stroke: "#5f00a0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.84670008,
    cy: 7.84670008,
    r: 7.34670008
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    strokeLinecap: "round",
    points: "7.84670008 2.29834355 7.76214732 7.84670008 11.4855337 11.5700864"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerIconGreen);
export default __webpack_public_path__ + "static/media/scheduler_icon_green.41c4331f21ab1165b8fd843132d12ad4.svg";
export { ForwardRef as ReactComponent };